import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';

import carouselFirstSlider from '../../../main/assets/images/skydive/dlc-flight-school.webp';
import carouselSecondSlider from '../../../main/assets/images/skydive/dlc-micro-drone.webp';
import carouselThirdSlider from '../../../main/assets/images/skydive/dlc-track-builder.webp';
import carouselFourthSlider from '../../../main/assets/images/skydive/dlc-drone-soccer.webp';
import carouselFirstTablet from '../../../main/assets/images/skydive/dlc-flight-school-tablet.webp';
import carouselSecondTablet from '../../../main/assets/images/skydive/dlc-micro-drone-tablet.webp';
import carouselThirdTablet from '../../../main/assets/images/skydive/dlc-track-builder-tablet.webp';
import carouselFourthTablet from '../../../main/assets/images/skydive/dlc-drone-soccer-tablet.webp';
import carouselFirstVertTablet from '../../../main/assets/images/skydive/dlc-flight-school-vert-tablet.webp';
import carouselSecondVertTablet from '../../../main/assets/images/skydive/dlc-micro-drone-vert-tablet.webp';
import carouselThirdVertTablet from '../../../main/assets/images/skydive/dlc-track-builder-vert-tablet.webp';
import carouselFourthVertTablet from '../../../main/assets/images/skydive/dlc-drone-soccer-tablet-vert.webp';
import carouselFirstMobile from '../../../main/assets/images/skydive/dlc-flight-school-mobile.webp';
import carouselSecondMobile from '../../../main/assets/images/skydive/dlc-micro-drone-mobile.webp';
import carouselThirdMobile from '../../../main/assets/images/skydive/dlc-track-builder-mobile.webp';
import carouselFourthMobile from '../../../main/assets/images/skydive/dlc-drone-soccer-mobile.webp';

export const DlcCarousel = () => {
  const settings = {
    className: 'center',
    centerMode: true,
    arrows: true,
    infinite: true,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    centerPadding: '10%',
    slidesToScroll: 1,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          arrows: false,
          centerPadding: '0px',
        },
      },
    ],
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      setWindowWidth(newWidth);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getImage = (images: { xs: any; sm: any; md: any; desktop: any }) => {
    if (windowWidth <= 767) return images.xs;
    if (windowWidth <= 991) return images.sm;
    if (windowWidth <= 1200) return images.md;
    return images.desktop;
  };

  const slides = [
    {
      images: {
        desktop: carouselFourthSlider,
        md: carouselFourthTablet,
        sm: carouselFourthVertTablet,
        xs: carouselFourthMobile,
      },

      link: 'https://store.steampowered.com/app/3896940/Drone_Soccer/',
      title: 'DRONE SOCCER',
      tags: ['DLC', 'Action', 'Match'],
      description:
        'Drone Soccer game mode brings high-speed, high-skill  action to your game. Take control of your drone and compete in an electrifying sport where flying, passing, and scoring happen mid-air.',
      buttonText: 'Buy DLC',
    },
    {
      images: {
        desktop: carouselFirstSlider,
        md: carouselFirstTablet,
        sm: carouselFirstVertTablet,
        xs: carouselFirstMobile,
      },

      link:
        'https://store.steampowered.com/app/2511190/FPV_SkyDive__Flight_School/',
      title: 'Flight School',
      tags: ['DLC', 'Freestyle', 'Racing'],
      description:
        "The Flight School DLC is your ultimate training ground to master FPV flying. Level up your skills with the most popular SkyDive DLC, featuring fun lessons and challenges that'll turn you into a pro in no time!",
      buttonText: 'Buy DLC',
    },
    {
      images: {
        desktop: carouselSecondSlider,
        md: carouselSecondTablet,
        sm: carouselSecondVertTablet,
        xs: carouselSecondMobile,
      },

      link:
        'https://store.steampowered.com/app/2384660/FPV_SkyDive__Micro_Drone_Edition/',
      title: 'MICRO DRONE EDITION',
      tags: ['DLC', 'Micro Drone', 'Whoop', 'Racing'],
      description:
        'The Micro Drone Edition DLC takes you into the world of micro drones. Hone your skills with fun challenges and tight courses that’ll make you a master of micro FPV flying!',
      buttonText: 'Buy DLC',
    },
    {
      images: {
        desktop: carouselThirdSlider,
        md: carouselThirdTablet,
        sm: carouselThirdVertTablet,
        xs: carouselThirdMobile,
      },

      link:
        'https://store.steampowered.com/app/3007600/FPV_SkyDive__Track_Builder/',
      title: 'TRACK BUILDER',
      tags: ['DLC', 'Racing', 'Whoop'],
      description:
        "Discover the ultimate tool for creating your own FPV tracks with Track Builder. Whether you're a beginner or an expert, this DLC offers everything you need to design dynamic and exciting tracks in no time.",
      buttonText: 'Buy DLC',
    },
  ];

  return (
    <div className="skydive-slider-section">
      <div className="skydive-slider-section-text">
        <div className="skydive-slider-section-titles">
          <h2 className="skydive-slider-section-subtitle">Flying is fun!</h2>
          <h3 className="skydive-slider-section-title">
            Discover a wide range of exciting content
          </h3>
        </div>
      </div>
      <div className="skydive-slider-carousel" style={{ width: '100%' }}>
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div key={index} style={{ padding: '20px' }}>
              {' '}
              <div
                className="skydive-slider-slide"
                style={{
                  background: `linear-gradient(247deg, rgba(255, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%), url(${getImage(
                    slide.images,
                  )})`,

                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  width: '100%',
                  overflow: 'hidden',
                  position: 'relative',
                }}
              >
                <h2 className="skydive-slider-title">{slide.title}</h2>
                <div className="skydive-slider-container">
                  <div className="skydive-slider-container-content">
                    <div className="skydive-slider-container-tags">
                      {slide.tags.map((tag, i) => (
                        <div key={i} className="skydive-slider-container-tag">
                          {tag}
                        </div>
                      ))}
                    </div>
                    <p className="skydive-slider-container-description">
                      {slide.description}
                    </p>
                  </div>
                  <div className="dreamX__discover--button">
                    <a
                      href={slide.link}
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="btn btn--primary btn--med"
                      onMouseDown={event => event.preventDefault()}
                    >
                      {slide.buttonText}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
